import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/core/constants';
import { ListedCar, CarList } from 'src/app/core/models/car.model';
import { CarService } from 'src/app/core/services/car.service';

@Component({
  selector: 'app-similar-cars',
  templateUrl: './similar-cars.component.html',
  styleUrls: ['./similar-cars.component.scss',],
})
export class SimilarCarsComponent implements OnChanges {

  cars: ListedCar[] = [];

  @Input() carId: string = '';
  @Input() tenure: number = AppConstants.ZERO;
  @Input() mileage: number = AppConstants.ZERO;

  constructor(private _carService: CarService) { }

  ngOnChanges(_changes: SimpleChanges): void {
    this.loadSimilarCars();
  }

  loadSimilarCars() {
    if (!this.carId || !this.tenure || !this.mileage) return;
    this._carService.getSimilarCars(this.carId, this.tenure, this.mileage).subscribe({
      next: (cars: CarList) => {
        this.cars = cars.vehicles;
      },
    });
  }

}
